/* Forever & Ever - Custom JavaScript
   1:1 match with Vite redesign interactivity */

/* Collection filters handled by inline script in theme.liquid */

(function() {
  'use strict';

  /* ===== SHOPIFY LOCALE ROOT PATH ===== */
  var FE_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ===== INTERSECTION OBSERVER FOR ANIMATIONS ===== */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('fe-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '-50px' });

  function initAnimations() {
    document.querySelectorAll('.fe-animate').forEach(function(el) { observer.observe(el); });
  }

  /* ===== NAVBAR SCROLL ===== */
  function initNavbar() {
    var navbar = document.querySelector('.fe-navbar');
    var announcementBar = document.getElementById('fe-announcement-bar');
    if (!navbar) return;

    function onScroll() {
      if (window.scrollY > 50) {
        navbar.classList.add('scrolled');
        navbar.style.top = '0';
        if (announcementBar) announcementBar.classList.add('hidden-bar');
      } else {
        navbar.classList.remove('scrolled');
        navbar.style.top = announcementBar ? announcementBar.offsetHeight + 'px' : '0';
        if (announcementBar) announcementBar.classList.remove('hidden-bar');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ===== MOBILE MENU ===== */
  function initMobileMenu() {
    var toggle = document.getElementById('fe-mobile-toggle');
    var menu = document.getElementById('fe-mobile-menu');
    var icon = document.getElementById('fe-mobile-icon');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function() {
      var isOpen = !menu.classList.contains('hidden');
      if (isOpen) {
        menu.classList.add('hidden');
        if (icon) icon.innerHTML = '<path d="M4 5h16"/><path d="M4 12h16"/><path d="M4 19h16"/>';
      } else {
        menu.classList.remove('hidden');
        if (icon) icon.innerHTML = '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>';
      }
    });

    menu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() { menu.classList.add('hidden'); });
    });
  }

  /* ===== CART DRAWER ===== */
  window.FECart = {
    open: function() {
      var backdrop = document.getElementById('fe-cart-backdrop');
      var drawer = document.getElementById('fe-cart-drawer');
      if (backdrop) { backdrop.classList.remove('hidden', 'closing'); }
      if (drawer) { drawer.classList.remove('hidden', 'closing'); }
      document.body.style.overflow = 'hidden';
    },
    close: function() {
      var backdrop = document.getElementById('fe-cart-backdrop');
      var drawer = document.getElementById('fe-cart-drawer');
      if (backdrop) { backdrop.classList.add('closing'); }
      if (drawer) { drawer.classList.add('closing'); }
      document.body.style.overflow = '';
      setTimeout(function() {
        if (backdrop) backdrop.classList.add('hidden');
        if (drawer) drawer.classList.add('hidden');
      }, 300);
    },
    updateCount: function(count) {
      document.querySelectorAll('.fe-cart-count').forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    },
    refresh: function() {
      var self = this;
      fetch(FE_ROOT + 'cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          self.updateCount(cart.item_count);
          self.renderDrawer(cart);
        });
    },
    addItem: function(variantId, quantity, properties) {
      quantity = quantity || 1;
      var body = { id: variantId, quantity: quantity };
      if (properties) body.properties = properties;
      return this.addItems([body]);
    },
    addItems: function(items) {
      var self = this;
      return fetch(FE_ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        // Fetch updated cart, render drawer, THEN open
        return fetch(FE_ROOT + 'cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          self.updateCount(cart.item_count);
          self.renderDrawer(cart);
          self.open();
        });
      });
    },
    changeItem: function(key, quantity) {
      var self = this;
      return fetch(FE_ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function() { self.refresh(); });
    },
    removeItem: function(key) {
      return this.changeItem(key, 0);
    },
    updateNote: function(note) {
      return fetch(FE_ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note })
      }).then(function(r) { return r.json(); });
    },
    formatMoney: function(cents) {
      var euros = Math.floor(cents / 100);
      var c = ('0' + (cents % 100)).slice(-2);
      return euros + ',<sup style="font-size:0.65em;position:relative;top:-0.3em;">' + c + '</sup>';
    },
    renderDrawer: function(cart) {
      var container = document.getElementById('fe-cart-items');
      var subtotalEl = document.getElementById('fe-cart-subtotal');
      var shippingEl = document.getElementById('fe-cart-shipping');
      var totalEl = document.getElementById('fe-cart-total');
      var emptyState = document.getElementById('fe-cart-empty');
      var filledState = document.getElementById('fe-cart-filled');
      var footerEl = document.getElementById('fe-cart-footer');
      var progressFill = document.getElementById('fe-cart-progress-fill');
      var progressMsg = document.getElementById('fe-cart-progress-msg');
      var progressHint = document.getElementById('fe-cart-progress-hint');
      var countBadge = document.getElementById('fe-cart-count-badge');

      var FREE_SHIPPING_QTY = 4;
      var SHIPPING_RATES = { NL: 695, BE: 695, DE: 995, FR: 1495 };
      var country = (drawerEl && drawerEl.dataset.country) || 'NL';
      var SHIPPING_COST = SHIPPING_RATES[country] || 1495;
      var self = this;

      if (!container) return;
      if (countBadge) countBadge.textContent = cart.item_count;

      if (cart.item_count === 0) {
        if (emptyState) emptyState.classList.remove('hidden');
        if (filledState) filledState.classList.add('hidden');
        if (footerEl) footerEl.classList.add('hidden');
        return;
      }

      if (emptyState) emptyState.classList.add('hidden');
      if (filledState) filledState.classList.remove('hidden');
      if (footerEl) footerEl.classList.remove('hidden');

      // Count only plants (exclude accessories like plantvoeding, blauwmaker)
      var plantCount = 0;
      cart.items.forEach(function(item) {
        var type = (item.product_type || '').toLowerCase();
        if (type.indexOf('voeding') === -1 && type.indexOf('verzorging') === -1 && !item.gift_card) {
          plantCount += item.quantity;
        }
      });

      var remainingQty = Math.max(0, FREE_SHIPPING_QTY - plantCount);
      var pct = Math.min(100, (plantCount / FREE_SHIPPING_QTY) * 100);
      if (progressFill) {
        progressFill.style.width = pct + '%';
        progressFill.className = 'fe-progress-fill ' + (pct >= 100 ? 'bg-green-500' : 'bg-brand-purple');
      }
      if (progressMsg) {
        var drawer = document.getElementById('fe-cart-drawer');
        if (remainingQty > 0) {
          var tpl = remainingQty === 1 ? (drawer.dataset.tProgressSingular || '') : (drawer.dataset.tProgressPlural || '');
          progressMsg.innerHTML = tpl.replace('[count]', remainingQty);
        } else {
          progressMsg.innerHTML = drawer.dataset.tProgressFree || '';
        }
      }
      if (progressHint) {
        progressHint.style.display = (remainingQty > 0 && remainingQty <= 1) ? '' : 'none';
      }

      var html = '';
      var T = window.FETranslations || {};
      cart.items.forEach(function(item) {
        var translatedTitle = (T.titles && T.titles[item.handle]) ? T.titles[item.handle] : item.product_title;
        var translatedVariant = item.variant_title;
        if (translatedVariant && translatedVariant !== 'Default Title' && T.colors) {
          var parts = translatedVariant.split(' / ');
          var translatedParts = parts.map(function(part) {
            var key = part.trim().toLowerCase().replace(/\s+/g, '');
            return T.colors[key] || part;
          });
          translatedVariant = translatedParts.join(' / ');
        }
        html += '<div class="flex gap-4">' +
          '<div class="w-20 h-20 rounded-xl overflow-hidden bg-gray-50 flex-shrink-0 border border-gray-100">' +
            '<img src="' + item.image + '" alt="' + translatedTitle + '" class="w-full h-full object-cover" loading="lazy">' +
          '</div>' +
          '<div class="flex-1 flex flex-col justify-between">' +
            '<div class="flex justify-between items-start">' +
              '<div>' +
                '<h3 class="font-bold text-gray-900 leading-tight">' + translatedTitle + '</h3>' +
                (translatedVariant && translatedVariant !== 'Default Title' ? '<p class="text-sm text-gray-500 mt-0.5">' + translatedVariant + '</p>' : '') +
              '</div>' +
              '<button onclick="FECart.removeItem(\'' + item.key + '\')" class="text-gray-400 hover:text-red-500 transition-colors p-1">' +
                '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="flex justify-between items-center mt-2">' +
              '<div class="flex items-center border border-gray-200 rounded-lg bg-white">' +
                '<button onclick="FECart.changeItem(\'' + item.key + '\',' + (item.quantity - 1) + ')" class="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-brand-purple transition-colors"><svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M5 12h14"/></svg></button>' +
                '<span class="w-8 text-center font-medium text-sm">' + item.quantity + '</span>' +
                '<button onclick="FECart.changeItem(\'' + item.key + '\',' + (item.quantity + 1) + ')" class="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-brand-purple transition-colors"><svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M5 12h14"/><path d="M12 5v14"/></svg></button>' +
              '</div>' +
              '<span class="font-bold text-gray-900 inline-flex items-baseline">' + self.formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      });
      container.innerHTML = html;

      var needsShipping = cart.items.some(function(item) { return item.requires_shipping; });
      var shippingRow = document.getElementById('fe-cart-shipping-row');
      var shipping = (!needsShipping || plantCount >= FREE_SHIPPING_QTY) ? 0 : SHIPPING_COST;
      if (shippingRow) shippingRow.style.display = needsShipping ? '' : 'none';
      if (subtotalEl) subtotalEl.innerHTML = self.formatMoney(cart.total_price);
      if (shippingEl && needsShipping) {
        var drawerEl = document.getElementById('fe-cart-drawer');
        shippingEl.innerHTML = shipping === 0 ? (drawerEl.dataset.tFree || 'Free') : self.formatMoney(shipping);
        shippingEl.className = shipping === 0 ? 'font-medium text-green-600' : 'font-medium text-gray-900';
      }
      if (totalEl) totalEl.innerHTML = self.formatMoney(cart.total_price + shipping);

      // Sync order note from server unless the customer is typing
      var noteEl = document.getElementById('fe-cart-note');
      if (noteEl && document.activeElement !== noteEl) {
        noteEl.value = cart.note || '';
      }

      // Always show upsell section (plantvoeding & blauwmaker stay visible)
    }
  };

  function initCartDrawer() {
    document.querySelectorAll('[data-cart-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) { e.preventDefault(); FECart.open(); });
    });
    var closeBtn = document.getElementById('fe-cart-close');
    var backdrop = document.getElementById('fe-cart-backdrop');
    if (closeBtn) closeBtn.addEventListener('click', function() { FECart.close(); });
    if (backdrop) backdrop.addEventListener('click', function() { FECart.close(); });

    document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
      // Skip product page button — handled by initProductAddToCart with upsell support
      if (btn.closest('[data-product-main]')) return;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        var qty = parseInt(btn.dataset.quantity || '1');
        if (variantId) FECart.addItem(parseInt(variantId), qty);
      });
    });

    var noteToggle = document.getElementById('fe-cart-note-toggle');
    var noteWrap = document.getElementById('fe-cart-note-wrap');
    var noteInput = document.getElementById('fe-cart-note');
    var noteStatus = document.getElementById('fe-cart-note-status');
    if (noteToggle && noteWrap) {
      noteToggle.addEventListener('click', function() {
        var isOpen = !noteWrap.classList.toggle('hidden');
        noteToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        var chevron = noteToggle.querySelector('svg:last-child');
        if (chevron) chevron.style.transform = isOpen ? 'rotate(180deg)' : '';
        if (isOpen && noteInput) noteInput.focus();
      });
    }
    if (noteInput) {
      var noteTimer = null;
      var lastSavedNote = noteInput.value;
      var saveNote = function() {
        if (noteInput.value === lastSavedNote) return;
        lastSavedNote = noteInput.value;
        FECart.updateNote(noteInput.value).then(function() {
          if (noteStatus) {
            noteStatus.style.visibility = 'visible';
            setTimeout(function() { noteStatus.style.visibility = 'hidden'; }, 2000);
          }
        });
      };
      noteInput.addEventListener('input', function() {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(saveNote, 600);
      });
      noteInput.addEventListener('blur', function() {
        clearTimeout(noteTimer);
        saveNote();
      });
    }

    var discountToggle = document.getElementById('fe-discount-toggle');
    var discountInput = document.getElementById('fe-discount-input');
    if (discountToggle && discountInput) {
      discountToggle.addEventListener('click', function() {
        discountInput.classList.toggle('open');
        discountToggle.classList.toggle('hidden');
      });
    }

    FECart.refresh();
  }

  /* ===== ACCORDIONS ===== */
  function closeAccordionPanel(panel) {
    panel.style.height = panel.scrollHeight + 'px';
    panel.offsetHeight; // force reflow
    panel.style.height = '0';
    panel.classList.remove('open');
  }

  function openAccordionPanel(panel) {
    panel.classList.add('open');
    var targetHeight = panel.scrollHeight;
    panel.style.height = targetHeight + 'px';
    panel.addEventListener('transitionend', function handler() {
      if (panel.classList.contains('open')) {
        panel.style.height = 'auto';
      }
      panel.removeEventListener('transitionend', handler);
    });
  }

  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var panel = trigger.parentElement.querySelector('.fe-accordion-content');
        var icon = trigger.querySelector('.fe-accordion-icon');
        var isOpen = panel && panel.classList.contains('open');

        var group = trigger.closest('[data-accordion-group]');
        if (group) {
          group.querySelectorAll('.fe-accordion-content.open').forEach(function(p) { closeAccordionPanel(p); });
          group.querySelectorAll('[data-accordion-trigger]').forEach(function(b) { b.classList.remove('active'); });
          group.querySelectorAll('[data-accordion-trigger] .fe-accordion-icon').forEach(function(i) { i.classList.remove('open'); });
        }

        if (!isOpen && panel) {
          openAccordionPanel(panel);
          trigger.classList.add('active');
          if (icon) icon.classList.add('open');
        } else if (isOpen && panel) {
          closeAccordionPanel(panel);
          trigger.classList.remove('active');
          if (icon) icon.classList.remove('open');
        }
      });
    });

    // Product page accordions (data-accordion-btn / data-accordion-panel)
    // Set up initial state: open panels get measured height, closed panels get height 0
    document.querySelectorAll('[data-accordion-btn]').forEach(function(btn) {
      var panel = btn.parentElement.querySelector('[data-accordion-panel]');
      if (!panel) return;

      // Add transition style
      panel.style.overflow = 'hidden';
      panel.style.transition = 'height 0.3s ease';

      if (panel.classList.contains('hidden')) {
        panel.classList.remove('hidden');
        panel.style.height = '0';
      } else {
        panel.style.height = 'auto';
      }

      // Rotate chevron for active buttons
      if (btn.classList.contains('active')) {
        var chevron = btn.querySelector('span:last-child');
        if (chevron) chevron.style.transform = 'rotate(180deg)';
      }

      btn.addEventListener('click', function() {
        var isOpen = parseInt(panel.style.height) !== 0 && panel.style.height !== '0px';

        var group = btn.closest('[data-accordion-group]');
        if (group) {
          // Close all panels in group
          group.querySelectorAll('[data-accordion-btn]').forEach(function(otherBtn) {
            var otherPanel = otherBtn.parentElement.querySelector('[data-accordion-panel]');
            if (otherPanel && otherPanel !== panel) {
              otherPanel.style.height = otherPanel.scrollHeight + 'px';
              otherPanel.offsetHeight; // force reflow
              otherPanel.style.height = '0';
              otherBtn.classList.remove('active');
              var chevron = otherBtn.querySelector('span:last-child');
              if (chevron) chevron.style.transform = '';
            }
          });
        }

        if (!isOpen) {
          panel.style.height = panel.scrollHeight + 'px';
          btn.classList.add('active');
          var chevron = btn.querySelector('span:last-child');
          if (chevron) chevron.style.transform = 'rotate(180deg)';
          panel.addEventListener('transitionend', function handler() {
            if (parseInt(panel.style.height) !== 0) panel.style.height = 'auto';
            panel.removeEventListener('transitionend', handler);
          });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          panel.offsetHeight; // force reflow
          panel.style.height = '0';
          btn.classList.remove('active');
          var chevron = btn.querySelector('span:last-child');
          if (chevron) chevron.style.transform = '';
        }
      });
    });

  }

  /* ===== COLOR SELECTOR ===== */
  function initColorSelectors() {
    document.querySelectorAll('[data-color-selector]').forEach(function(container) {
      var swatches = container.querySelectorAll('[data-color-swatch]');
      var mainImage = document.querySelector('[data-main-image]');
      var colorLabel = document.querySelector('[data-color-label]');
      var addToCartBtn = document.querySelector('[data-add-to-cart]');

      swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function(e) {
          // Defensive: ignore clicks on out-of-stock swatches.
          if (swatch.disabled || swatch.dataset.variantUnavailable === 'true') {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          // Update active state on swatches
          swatches.forEach(function(s) {
            s.classList.remove('border-brand-purple', 'ring-2', 'ring-brand-purple/30', 'scale-110');
            s.classList.add('border-gray-200');
            s.innerHTML = '';
          });
          swatch.classList.add('border-brand-purple', 'ring-2', 'ring-brand-purple/30', 'scale-110');
          swatch.classList.remove('border-gray-200');
          swatch.innerHTML = '<svg class="w-5 h-5 text-white drop-shadow-md" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>';

          // Update main image
          if (mainImage && swatch.dataset.colorImage) mainImage.src = swatch.dataset.colorImage;

          // Update color label
          if (colorLabel && swatch.dataset.colorName) colorLabel.textContent = swatch.dataset.colorName;

          // Update variant ID on add-to-cart button + restore enabled state
          if (addToCartBtn && swatch.dataset.variantId) {
            addToCartBtn.dataset.variantId = swatch.dataset.variantId;
            addToCartBtn.disabled = false;
            addToCartBtn.removeAttribute('aria-disabled');
            addToCartBtn.classList.remove('!opacity-50', '!cursor-not-allowed');
            var addSpan = addToCartBtn.querySelector('[data-atc-add]');
            var soldOutSpan = addToCartBtn.querySelector('[data-atc-sold-out]');
            if (addSpan) addSpan.classList.remove('hidden');
            if (soldOutSpan) soldOutSpan.classList.add('hidden');
          }

          // Update displayed price
          var priceEl = document.querySelector('[data-product-price]');
          if (priceEl && swatch.dataset.variantPrice) priceEl.innerHTML = swatch.dataset.variantPrice;

          // Update URL so page reload keeps selection
          var url = new URL(window.location);
          url.searchParams.set('variant', swatch.dataset.variantId);
          window.history.replaceState({}, '', url);

          // Update color badge
          var badge = document.querySelector('[data-color-badge]');
          if (badge && swatch.dataset.colorName) badge.textContent = swatch.dataset.colorName;

          // Update thumbnail active states
          document.querySelectorAll('[data-thumbnail]').forEach(function(thumb) {
            thumb.classList.remove('border-brand-purple', 'ring-2', 'ring-brand-purple/20');
            thumb.classList.add('border-transparent');
          });

          // Show/hide blauwmaker upsell on product page
          var blauwUpsell = document.querySelector('[data-upsell-blauwmaker]');
          if (blauwUpsell) {
            var name = (swatch.dataset.colorName || '').toLowerCase();
            blauwUpsell.classList.toggle('hidden', !(name.includes('blauw') || name.includes('blue')));
          }
        });
      });
    });

    // Thumbnail click: update main image
    document.querySelectorAll('[data-thumbnail]').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var mainImage = document.querySelector('[data-main-image]');
        if (mainImage && thumb.dataset.imageUrl) mainImage.src = thumb.dataset.imageUrl;

        // Update active thumbnail border
        document.querySelectorAll('[data-thumbnail]').forEach(function(t) {
          t.classList.remove('border-brand-purple', 'ring-2', 'ring-brand-purple/20');
          t.classList.add('border-transparent');
        });
        thumb.classList.add('border-brand-purple', 'ring-2', 'ring-brand-purple/20');
        thumb.classList.remove('border-transparent');
      });
    });
  }

  /* ===== QUANTITY SELECTOR ===== */
  function initQuantitySelectors() {
    var minus = document.querySelector('[data-quantity-minus]');
    var plus = document.querySelector('[data-quantity-plus]');
    var value = document.querySelector('[data-quantity-value]');
    if (!value) return;

    if (minus) minus.addEventListener('click', function() {
      var val = parseInt(value.textContent || value.value || '1');
      var newVal = Math.max(1, val - 1);
      if (value.tagName === 'INPUT') value.value = newVal; else value.textContent = newVal;
    });
    if (plus) plus.addEventListener('click', function() {
      var val = parseInt(value.textContent || value.value || '1');
      var newVal = val + 1;
      if (value.tagName === 'INPUT') value.value = newVal; else value.textContent = newVal;
    });
  }

  /* ===== FAQ SEARCH ===== */
  function initFAQSearch() {
    var searchInput = document.getElementById('fe-faq-search');
    if (!searchInput) return;
    searchInput.addEventListener('input', function() {
      var query = searchInput.value.toLowerCase();
      document.querySelectorAll('[data-faq-item]').forEach(function(item) {
        item.style.display = item.textContent.toLowerCase().includes(query) ? '' : 'none';
      });
      document.querySelectorAll('[data-faq-category]').forEach(function(cat) {
        var visible = cat.querySelectorAll('[data-faq-item]:not([style*="display: none"])');
        cat.style.display = visible.length > 0 ? '' : 'none';
      });
    });
  }

  /* ===== TABS ===== */
  function initTabs() {
    document.querySelectorAll('[data-tab-btn]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var group = trigger.closest('[data-tab-group]');
        var tabId = trigger.dataset.tabBtn;
        if (!group) return;
        group.querySelectorAll('[data-tab-btn]').forEach(function(t) {
          t.classList.remove('fe-btn-primary', 'active');
          t.classList.add('fe-btn-secondary');
        });
        group.querySelectorAll('[data-tab-panel]').forEach(function(p) { p.classList.add('hidden'); });
        trigger.classList.remove('fe-btn-secondary');
        trigger.classList.add('fe-btn-primary', 'active');
        var panel = group.querySelector('[data-tab-panel="' + tabId + '"]');
        if (panel) panel.classList.remove('hidden');
      });
    });
  }

  /* ===== COLLECTION FILTERS ===== */
  /* Handled by inline script in theme.liquid via event delegation */
  function initCollectionFilters() {
    /* no-op: filter logic lives in theme.liquid to avoid CDN cache issues */
  }

  /* ===== VARIANT MODAL ===== */
  window.FEVariantModal = {
    selectedVariant: null,
    selectedQuantity: 1,
    nutritionChecked: false,
    blauwmakerChecked: false,

    translateTitle: function(handle, fallback) {
      return (window.FETranslations && window.FETranslations.titles && window.FETranslations.titles[handle]) || fallback;
    },
    translateColor: function(colorName) {
      if (!window.FETranslations || !window.FETranslations.colors) return colorName;
      var key = colorName.toLowerCase().replace(/\s+/g, '-');
      return window.FETranslations.colors[key] || colorName;
    },

    isGiftCard: false,

    open: function(productHandle, giftCard) {
      var self = this;
      self.isGiftCard = !!giftCard;
      // Show modal + backdrop immediately
      var modal = document.getElementById('fe-variant-modal');
      var backdrop = document.getElementById('fe-variant-modal-backdrop');
      if (modal) modal.style.display = 'block';
      if (backdrop) backdrop.style.display = 'block';
      document.body.style.overflow = 'hidden';

      fetch(FE_ROOT + 'products/' + productHandle + '.js')
        .then(function(r) {
          if (!r.ok) throw new Error('Product not found: ' + productHandle);
          return r.json();
        })
        .then(function(product) { self.render(product); })
        .catch(function(err) {
          console.error('[FE VariantModal]', err);
          // Show error in modal title
          var titleEl = document.getElementById('fe-modal-title');
          if (titleEl) titleEl.textContent = (window.FETranslations && window.FETranslations.errorLoading) || 'Could not load product';
        });
    },

    render: function(product) {
      var modal = document.getElementById('fe-variant-modal');
      var backdrop = document.getElementById('fe-variant-modal-backdrop');
      if (!modal) return;

      var titleEl = document.getElementById('fe-modal-title');
      var priceEl = document.getElementById('fe-modal-price');
      var imageEl = document.getElementById('fe-modal-image');
      var swatchContainer = document.getElementById('fe-modal-swatches');
      var colorLabel = document.getElementById('fe-modal-color-name');
      var self = this;

      // Reset state
      self.selectedQuantity = 1;
      self.nutritionChecked = false;
      self.blauwmakerChecked = false;
      var quantityEl = document.getElementById('fe-modal-quantity');
      if (quantityEl) quantityEl.textContent = '1';

      // Fill product info (use translated title if available)
      if (titleEl) titleEl.textContent = self.translateTitle(product.handle, product.title);
      if (priceEl) priceEl.innerHTML = FECart.formatMoney(product.price);
      if (imageEl) imageEl.src = product.featured_image;

      // Switch variant label based on gift card mode
      var variantLabel = document.getElementById('fe-modal-variant-label');
      if (variantLabel) {
        variantLabel.textContent = self.isGiftCard
          ? (variantLabel.dataset.labelAmount || 'Choose an amount:')
          : (variantLabel.dataset.labelColor || 'Choose a colour:');
      }

      // Hide/show upsells based on gift card mode
      var upsellsContainer = document.getElementById('fe-modal-upsells');
      if (upsellsContainer) upsellsContainer.style.display = self.isGiftCard ? 'none' : '';

      // Hide "Geselecteerd:" row for gift cards
      var selectedRow = document.getElementById('fe-modal-selected-row');
      if (selectedRow) selectedRow.style.display = self.isGiftCard ? 'none' : '';

      // Show/hide gift card delivery method
      var gcDelivery = document.getElementById('fe-modal-gc-delivery');
      var gcFields = document.getElementById('fe-modal-gc-fields');
      if (gcDelivery) {
        gcDelivery.style.display = self.isGiftCard ? '' : 'none';
        // Reset delivery state
        self.gcDeliveryMode = 'self';
        if (gcFields) gcFields.classList.add('hidden');
        // Reset button styles
        var selfBtn = gcDelivery.querySelector('[data-modal-gc-delivery="self"]');
        var recipBtn = gcDelivery.querySelector('[data-modal-gc-delivery="recipient"]');
        if (selfBtn) { selfBtn.classList.add('border-brand-purple','text-brand-purple'); selfBtn.classList.remove('border-gray-200','text-gray-700'); selfBtn.style.backgroundColor = 'rgba(82,40,115,0.05)'; }
        if (recipBtn) { recipBtn.classList.add('border-gray-200','text-gray-700'); recipBtn.classList.remove('border-brand-purple','text-brand-purple'); recipBtn.style.backgroundColor = ''; }
        // Clear form fields
        var emailInput = document.getElementById('fe-modal-gc-email');
        var nameInput = document.getElementById('fe-modal-gc-name');
        var msgInput = document.getElementById('fe-modal-gc-message');
        if (emailInput) emailInput.value = '';
        if (nameInput) nameInput.value = '';
        if (msgInput) msgInput.value = '';
        // Bind delivery toggle handlers
        if (selfBtn) selfBtn.onclick = function() {
          self.gcDeliveryMode = 'self';
          selfBtn.classList.add('border-brand-purple','text-brand-purple'); selfBtn.classList.remove('border-gray-200','text-gray-700'); selfBtn.style.backgroundColor = 'rgba(82,40,115,0.05)';
          recipBtn.classList.add('border-gray-200','text-gray-700'); recipBtn.classList.remove('border-brand-purple','text-brand-purple'); recipBtn.style.backgroundColor = '';
          gcFields.classList.add('hidden');
        };
        if (recipBtn) recipBtn.onclick = function() {
          self.gcDeliveryMode = 'recipient';
          recipBtn.classList.add('border-brand-purple','text-brand-purple'); recipBtn.classList.remove('border-gray-200','text-gray-700'); recipBtn.style.backgroundColor = 'rgba(82,40,115,0.05)';
          selfBtn.classList.add('border-gray-200','text-gray-700'); selfBtn.classList.remove('border-brand-purple','text-brand-purple'); selfBtn.style.backgroundColor = '';
          gcFields.classList.remove('hidden');
          if (emailInput) emailInput.focus();
        };
      }

      // Set first AVAILABLE variant as selected (skip out-of-stock ones)
      self.selectedVariant = product.variants.find(function(v) {
        return self.isVariantAvailable(v);
      }) || product.variants[0];

      if (self.isGiftCard) {
        // --- GIFT CARD MODE: price buttons instead of color swatches ---
        if (swatchContainer) {
          var html = '';
          product.variants.forEach(function(v, i) {
            var isFirst = i === 0;
            html += '<button data-modal-swatch'
              + ' data-variant-id="' + v.id + '"'
              + ' data-variant-price="' + v.price + '"'
              + ' class="px-4 py-2 rounded-lg border-2 text-sm font-bold transition-all '
              + (isFirst ? 'border-brand-purple bg-brand-purple text-white' : 'border-gray-200 bg-white text-gray-900 hover:border-gray-300')
              + '">' + FECart.formatMoney(v.price) + '</button>';
          });
          swatchContainer.innerHTML = html;

          if (colorLabel) colorLabel.innerHTML = FECart.formatMoney(product.variants[0].price);

          // Bind price button click handlers
          modal.querySelectorAll('[data-modal-swatch]').forEach(function(btn) {
            btn.addEventListener('click', function() {
              // Deselect all
              modal.querySelectorAll('[data-modal-swatch]').forEach(function(b) {
                b.classList.remove('border-brand-purple', 'bg-brand-purple', 'text-white');
                b.classList.add('border-gray-200', 'bg-white', 'text-gray-900');
              });
              // Select clicked
              btn.classList.add('border-brand-purple', 'bg-brand-purple', 'text-white');
              btn.classList.remove('border-gray-200', 'bg-white', 'text-gray-900');

              // Update selected variant + price display
              self.selectedVariant = product.variants.find(function(v) {
                return v.id === parseInt(btn.dataset.variantId);
              }) || product.variants[0];
              if (priceEl) priceEl.innerHTML = FECart.formatMoney(self.selectedVariant.price);
              if (colorLabel) colorLabel.innerHTML = FECart.formatMoney(self.selectedVariant.price);
            });
          });
        }
      } else {
        // --- PLANT MODE: color swatches ---
        // Find the color option index (handle both string and object formats)
        var colorOption = null;
        product.options.forEach(function(opt, i) {
          var name = (typeof opt === 'string') ? opt : (opt.name || opt || '');
          var lower = name.toLowerCase();
          if (lower === 'kleur' || lower === 'color' || lower === 'colour') colorOption = i;
        });
        // Fallback: if only one option exists, assume it's color
        if (colorOption === null && product.options.length === 1 && product.variants.length > 1) {
          colorOption = 0;
        }

        if (swatchContainer && colorOption !== null) {
          var html = '';
          var addedColors = {};
          var firstColorName = '';
          var firstColorRaw = '';

          // Pick the first AVAILABLE color as the default selected swatch.
          var firstAvailableColor = null;
          product.variants.forEach(function(v) {
            if (firstAvailableColor !== null) return;
            if (self.isVariantAvailable(v)) firstAvailableColor = v.options[colorOption];
          });

          product.variants.forEach(function(v) {
            var colorName = v.options[colorOption];
            if (addedColors[colorName]) return;
            addedColors[colorName] = true;
            var translatedColorName = self.translateColor(colorName);
            var isUnavailable = !self.isVariantAvailable(v);
            var isFirst = (firstAvailableColor !== null)
              ? colorName === firstAvailableColor
              : Object.keys(addedColors).length === 1;
            if (isFirst) { firstColorName = translatedColorName; firstColorRaw = colorName; }
            var hex = self.getColorHex(colorName);

            html += '<button data-modal-swatch'
              + ' data-variant-id="' + v.id + '"'
              + ' data-variant-image="' + (v.featured_image ? v.featured_image.src : product.featured_image) + '"'
              + ' data-color-name="' + translatedColorName + '"'
              + ' data-color-raw="' + colorName + '"'
              + (isUnavailable ? ' data-variant-unavailable="true" disabled aria-disabled="true" title="' + (window.FETranslations && window.FETranslations.soldOut ? window.FETranslations.soldOut : 'Sold out') + '"' : '')
              + ' class="fe-color-swatch w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all '
              + (isFirst ? 'border-brand-purple scale-110' : 'border-transparent hover:scale-105 shadow-sm')
              + '" style="background-color:' + hex + '">'
              + (isFirst && !isUnavailable ? '<svg class="w-5 h-5 text-white drop-shadow-md" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>' : '')
              + '</button>';
          });
          swatchContainer.innerHTML = html;

          if (colorLabel) colorLabel.textContent = firstColorName;

          // Show/hide blauwmaker based on initial color (use raw Dutch name for matching)
          self.updateBlauwmakerVisibility(firstColorRaw);

          // Bind swatch click handlers
          modal.querySelectorAll('[data-modal-swatch]').forEach(function(swatch) {
            swatch.addEventListener('click', function(e) {
              // Defensive: ignore clicks on out-of-stock swatches.
              if (swatch.disabled || swatch.dataset.variantUnavailable === 'true') {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              // Deselect all swatches
              modal.querySelectorAll('[data-modal-swatch]').forEach(function(s) {
                s.classList.remove('border-brand-purple', 'scale-110');
                s.classList.add('border-transparent');
                s.innerHTML = '';
              });
              // Select clicked swatch
              swatch.classList.add('border-brand-purple', 'scale-110');
              swatch.classList.remove('border-transparent');
              swatch.innerHTML = '<svg class="w-5 h-5 text-white drop-shadow-md" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>';

              // Update image
              if (imageEl && swatch.dataset.variantImage) imageEl.src = swatch.dataset.variantImage;

              // Update color label
              if (colorLabel) colorLabel.textContent = swatch.dataset.colorName;

              // Update selected variant
              self.selectedVariant = product.variants.find(function(v) {
                return v.id === parseInt(swatch.dataset.variantId);
              }) || product.variants[0];

              // Show/hide blauwmaker + reset its checked state (use raw name for matching)
              self.blauwmakerChecked = false;
              self.updateBlauwmakerVisibility(swatch.dataset.colorRaw || swatch.dataset.colorName);
              self.renderUpsellState('blauwmaker');
            });
          });
        }
      }

      // Reset upsell UI (only relevant for non-gift-card)
      if (!self.isGiftCard) {
        self.renderUpsellState('nutrition');
        self.renderUpsellState('blauwmaker');

        // Bind upsell click handlers
        var nutritionEl = document.getElementById('fe-modal-upsell-nutrition');
        var blauwmakerEl = document.getElementById('fe-modal-upsell-blauwmaker');

        if (nutritionEl) {
          nutritionEl.onclick = function() {
            self.nutritionChecked = !self.nutritionChecked;
            self.renderUpsellState('nutrition');
          };
        }
        if (blauwmakerEl) {
          blauwmakerEl.onclick = function() {
            self.blauwmakerChecked = !self.blauwmakerChecked;
            self.renderUpsellState('blauwmaker');
          };
        }
      }

      // Modal already shown by open()
    },

    updateQuantity: function(delta) {
      this.selectedQuantity = Math.max(1, this.selectedQuantity + delta);
      var el = document.getElementById('fe-modal-quantity');
      if (el) el.textContent = this.selectedQuantity;
    },

    updateBlauwmakerVisibility: function(colorName) {
      var blauwmakerEl = document.getElementById('fe-modal-upsell-blauwmaker');
      if (!blauwmakerEl) return;
      var cn = (colorName || '').toLowerCase();
      var isBlue = cn.includes('blauw') || cn.includes('blue');
      blauwmakerEl.style.display = isBlue ? '' : 'none';
    },

    renderUpsellState: function(type) {
      var isNutrition = type === 'nutrition';
      var wrapper = document.getElementById(isNutrition ? 'fe-modal-upsell-nutrition' : 'fe-modal-upsell-blauwmaker');
      if (!wrapper) return;
      // For blauwmaker, the visual element is the inner .fe-upsell-option child
      var el = isNutrition ? wrapper : (wrapper.querySelector('.fe-upsell-option') || wrapper);
      var checked = isNutrition ? this.nutritionChecked : this.blauwmakerChecked;
      var plusIcon = el.querySelector('.fe-icon-plus');
      var checkIcon = el.querySelector('.fe-icon-check');
      var indicator = el.querySelector('.fe-upsell-indicator');

      var color = isNutrition ? '#522873' : '#3b82f6';
      var bgColor = isNutrition ? 'rgba(82, 40, 115, 0.08)' : 'rgba(59, 130, 246, 0.08)';

      if (checked) {
        // Use setProperty with !important to override Tailwind's important:true
        el.style.setProperty('border-color', color, 'important');
        el.style.setProperty('background-color', bgColor, 'important');
        if (indicator) {
          indicator.style.setProperty('border-color', color, 'important');
          indicator.style.setProperty('background-color', color, 'important');
        }
        if (plusIcon) plusIcon.classList.add('hidden');
        if (checkIcon) checkIcon.classList.remove('hidden');
      } else {
        el.style.removeProperty('border-color');
        el.style.removeProperty('background-color');
        if (indicator) {
          indicator.style.removeProperty('border-color');
          indicator.style.removeProperty('background-color');
        }
        if (plusIcon) plusIcon.classList.remove('hidden');
        if (checkIcon) checkIcon.classList.add('hidden');
      }
    },

    gcDeliveryMode: 'self',

    addToCart: function() {
      var self = this;
      if (!self.selectedVariant) return;
      // Block adding sold-out variants to the cart.
      if (!self.isVariantAvailable(self.selectedVariant)) return;

      var mainItem = { id: self.selectedVariant.id, quantity: self.selectedQuantity };

      // For gift cards, collect delivery properties
      if (self.isGiftCard && self.gcDeliveryMode === 'recipient') {
        var email = document.getElementById('fe-modal-gc-email');
        var name = document.getElementById('fe-modal-gc-name');
        var msg = document.getElementById('fe-modal-gc-message');
        var props = {};
        if (email && email.value) props['Recipient email'] = email.value;
        if (name && name.value) props['Recipient name'] = name.value;
        if (msg && msg.value) props['Message'] = msg.value;
        if (Object.keys(props).length > 0) mainItem.properties = props;
      }

      var items = [mainItem];

      // Add plantvoeding if checked (not for gift cards)
      if (!self.isGiftCard && self.nutritionChecked) {
        var nutritionEl = document.getElementById('fe-modal-upsell-nutrition');
        if (nutritionEl && nutritionEl.dataset.variantId) {
          items.push({ id: parseInt(nutritionEl.dataset.variantId), quantity: 1 });
        }
      }

      // Add blauwmaker if checked (and visible, not for gift cards)
      if (!self.isGiftCard && self.blauwmakerChecked) {
        var blauwmakerEl = document.getElementById('fe-modal-upsell-blauwmaker');
        if (blauwmakerEl && blauwmakerEl.dataset.variantId && blauwmakerEl.style.display !== 'none') {
          items.push({ id: parseInt(blauwmakerEl.dataset.variantId), quantity: 1 });
        }
      }

      FECart.addItems(items);
      self.close();
    },

    close: function() {
      var modal = document.getElementById('fe-variant-modal');
      var backdrop = document.getElementById('fe-variant-modal-backdrop');
      if (modal) modal.style.display = 'none';
      if (backdrop) backdrop.style.display = 'none';
      document.body.style.overflow = '';
    },

    // True if variant is in stock and orderable.
    // Treats tracked-with-zero-or-negative-stock as unavailable regardless of policy
    // so 'continue selling when out of stock' variants are also blocked.
    isVariantAvailable: function(v) {
      if (!v) return false;
      if (v.available === false) return false;
      if (v.inventory_management && typeof v.inventory_quantity === 'number' && v.inventory_quantity <= 0) {
        return false;
      }
      return true;
    },

    getColorHex: function(name) {
      var n = (name || '').toLowerCase();
      var map = {
        'blauw': '#6B8CC7', 'blue': '#6B8CC7',
        'lichtblauw': '#7dd3fc', 'light blue': '#7dd3fc',
        'donkerblauw': '#1e40af', 'dark blue': '#1e40af',
        'roze': '#D66B8E', 'pink': '#D66B8E',
        'lichtroze': '#fbcfe8', 'light pink': '#fbcfe8',
        'rood': '#C73B3B', 'red': '#C73B3B',
        'wit': '#F5F5F5', 'white': '#F5F5F5',
        'paars': '#8B5A96', 'purple': '#8B5A96',
        'lila': '#c084fc', 'lilac': '#c084fc',
        'violet': '#8b5cf6',
        'geel': '#facc15', 'yellow': '#facc15',
        'groen': '#22c55e', 'green': '#22c55e',
        'oranje': '#f97316', 'orange': '#f97316',
        'zalm': '#fda4af', 'salmon': '#fda4af',
        'koraal': '#fb7185', 'coral': '#fb7185',
        'bordeaux': '#881337', 'burgundy': '#881337',
        'magenta': '#d946ef',
        'creme': '#fef3c7', 'cream': '#fef3c7',
        'ivoor': '#fffff0', 'ivory': '#fffff0',
        'gemengd': '#FFD700', 'mixed': '#FFD700'
      };
      return map[n] || '#9ca3af';
    }
  };

  function initVariantModal() {
    // Use event delegation so buttons work even if rendered after init
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-open-variant-modal]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.dataset.productHandle;
      var isGiftCard = btn.dataset.giftCard === 'true';
      if (handle) FEVariantModal.open(handle, isGiftCard);
    });
  }

  /* ===== PRODUCT PAGE: ADD TO CART + UPSELL TOGGLES ===== */
  function initProductAddToCart() {
    // Gift card delivery method toggle
    var gcDeliveryBtns = document.querySelectorAll('[data-gc-delivery]');
    var gcFields = document.getElementById('gc-recipient-fields');
    gcDeliveryBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var mode = this.getAttribute('data-gc-delivery');
        gcDeliveryBtns.forEach(function(b) {
          b.classList.remove('border-brand-purple', 'text-brand-purple');
          b.style.backgroundColor = '';
          b.classList.add('border-gray-200', 'text-gray-700');
        });
        this.classList.remove('border-gray-200', 'text-gray-700');
        this.classList.add('border-brand-purple', 'text-brand-purple');
        this.style.backgroundColor = 'rgba(82,40,115,0.05)';
        if (gcFields) {
          if (mode === 'recipient') {
            gcFields.classList.remove('hidden');
          } else {
            gcFields.classList.add('hidden');
          }
        }
      });
    });

    // Upsell toggle visuals
    document.querySelectorAll('[data-upsell-toggle]').forEach(function(el) {
      el.addEventListener('click', function() {
        var isChecked = el.dataset.upsellChecked === 'true';
        el.dataset.upsellChecked = isChecked ? 'false' : 'true';
        var indicator = el.querySelector('[data-upsell-indicator]');
        if (!indicator) return;
        var plusIcon = indicator.querySelector('.fe-icon-plus');
        var checkIcon = indicator.querySelector('.fe-icon-check');
        var color = el.dataset.upsellColor === 'blue' ? '#3b82f6' : '#522873';

        if (!isChecked) {
          indicator.style.backgroundColor = color;
          indicator.style.borderColor = color;
          checkIcon.style.color = '#fff';
          plusIcon.classList.add('hidden');
          checkIcon.classList.remove('hidden');
        } else {
          indicator.style.backgroundColor = '';
          indicator.style.borderColor = '';
          checkIcon.style.color = '';
          plusIcon.classList.remove('hidden');
          checkIcon.classList.add('hidden');
        }
      });
    });

    // Single add-to-cart handler (includes upsells)
    var addBtn = document.querySelector('[data-add-to-cart]');
    if (!addBtn) return;
    addBtn.removeAttribute('onclick');
    addBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (addBtn.disabled) return;

      var variantId = parseInt(addBtn.getAttribute('data-variant-id'));
      var qtyEl = document.querySelector('[data-quantity-value]');
      var qty = qtyEl ? parseInt(qtyEl.textContent || '1') : 1;
      if (!variantId) return;

      var mainItem = { id: variantId, quantity: qty };

      // For gift cards: collect recipient properties
      var productMain = document.querySelector('[data-product-main]');
      if (productMain && productMain.dataset.isGiftCard === 'true') {
        var deliveryBtn = document.querySelector('[data-gc-delivery].border-brand-purple');
        var deliveryMode = deliveryBtn ? deliveryBtn.getAttribute('data-gc-delivery') : 'self';
        if (deliveryMode === 'recipient') {
          var email = document.getElementById('gc-recipient-email');
          var name = document.getElementById('gc-recipient-name');
          var msg = document.getElementById('gc-recipient-message');
          var props = {};
          if (email && email.value) props['Recipient email'] = email.value;
          if (name && name.value) props['Recipient name'] = name.value;
          if (msg && msg.value) props['Message'] = msg.value;
          if (Object.keys(props).length > 0) mainItem.properties = props;
        }
      }

      var items = [mainItem];

      // Collect checked upsells (only visible ones)
      document.querySelectorAll('[data-upsell-toggle]').forEach(function(el) {
        if (el.dataset.upsellChecked === 'true') {
          // Skip if hidden (blauwmaker hidden when not blue variant)
          if (el.offsetParent === null) return;
          var upsellId = parseInt(el.dataset.upsellVariantId);
          if (upsellId) items.push({ id: upsellId, quantity: 1 });
        }
      });

      // Disable button, show loading state
      addBtn.disabled = true;
      var originalText = addBtn.innerHTML;
      addBtn.innerHTML = '<svg class="w-5 h-5 mr-2 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>Toevoegen...';

      FECart.addItems(items).then(function() {
        // Reset button
        addBtn.disabled = false;
        addBtn.innerHTML = originalText;
      }).catch(function() {
        addBtn.disabled = false;
        addBtn.innerHTML = originalText;
      });
    });
  }

  // Keep for backwards compat but now a no-op since merged above
  function initProductUpsells() {}

  /* ===== TRUST BAR AUTOPLAY CAROUSEL ===== */
  function initFadeCarousel(id, interval) {
    var carousel = document.getElementById(id);
    if (!carousel) return;
    var items = Array.from(carousel.children);
    if (items.length < 2) return;
    var currentIndex = 0;
    items[0].classList.add('fe-trust-active');
    setInterval(function() {
      items[currentIndex].classList.remove('fe-trust-active');
      currentIndex = (currentIndex + 1) % items.length;
      items[currentIndex].classList.add('fe-trust-active');
    }, interval || 3000);
  }

  function initTrustCarousel() {
    initFadeCarousel('fe-trust-carousel', 3000);
    initFadeCarousel('fe-announce-carousel', 3000);
  }

  /* ===== MOBILE CAROUSEL DOTS ===== */
  function initCarouselDots() {
    if (window.innerWidth >= 768) return;
    document.querySelectorAll('.fe-mobile-carousel').forEach(function(carousel) {
      var items = Array.from(carousel.children);
      if (items.length < 2) return;

      // Create dots container
      var dotsContainer = document.createElement('div');
      dotsContainer.className = 'fe-carousel-dots';
      items.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'fe-carousel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Ga naar slide ' + (i + 1));
        dot.addEventListener('click', function() {
          items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        dotsContainer.appendChild(dot);
      });
      carousel.parentNode.insertBefore(dotsContainer, carousel.nextSibling);

      // Update active dot on scroll
      var scrollTimeout;
      carousel.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          var scrollLeft = carousel.scrollLeft;
          var containerWidth = carousel.offsetWidth;
          var activeIndex = Math.round(scrollLeft / containerWidth);
          dotsContainer.querySelectorAll('.fe-carousel-dot').forEach(function(dot, i) {
            dot.classList.toggle('active', i === activeIndex);
          });
        }, 50);
      }, { passive: true });
    });
  }

  /* ===== COLLECTION SWATCH HOVER ===== */
  function initCollectionSwatchHover() {
    document.querySelectorAll('.fe-product-card').forEach(function(card) {
      var mainImg = card.querySelector('.fe-product-img');
      var hoverImg = card.querySelector('.fe-product-hover-img');
      if (!mainImg) return;
      var originalSrc = mainImg.src;
      var handle = card.dataset.productHandle;
      if (!handle) return;
      var variantImageMap = null;

      function ensureVariantImages() {
        if (variantImageMap) return Promise.resolve(variantImageMap);
        return fetch(FE_ROOT + 'products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            variantImageMap = {};
            product.variants.forEach(function(v) {
              variantImageMap[v.id] = v.featured_image ? v.featured_image.src : product.featured_image;
            });
            return variantImageMap;
          });
      }

      card.querySelectorAll('[data-swatch-card]').forEach(function(swatch) {
        swatch.addEventListener('mouseenter', function() {
          ensureVariantImages().then(function(map) {
            var img = map[swatch.dataset.variantId];
            if (img) {
              mainImg.src = img;
              // Override CSS hover: keep main image visible, hide hover overlay
              mainImg.style.opacity = '1';
              if (hoverImg) hoverImg.style.opacity = '0';
            }
          });
        });
        swatch.addEventListener('mouseleave', function() {
          mainImg.src = originalSrc;
          // Remove inline styles so CSS hover works normally again
          mainImg.style.removeProperty('opacity');
          if (hoverImg) hoverImg.style.removeProperty('opacity');
        });
      });
    });
  }

  /* ===== INIT ===== */
  function init() {
    var fns = [
      initAnimations, initNavbar, initMobileMenu, initCartDrawer,
      initAccordions, initColorSelectors, initQuantitySelectors,
      initFAQSearch, initTabs, initCollectionFilters,
      initVariantModal, initProductAddToCart, initProductUpsells,
      initTrustCarousel, initCarouselDots, initCollectionSwatchHover
    ];
    fns.forEach(function(fn) {
      try { fn(); } catch(e) { console.error('[FE init]', fn.name, e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
